import LinksList from './LinksList';

export default LinksList;
